import React from 'react'
import './About.css';


export default function AboutUs() {


    
    return (
        <>
            <div className='container' style={{ color: "white", marginTop: "60px" }}>
                <div className="row d-flex justify-content-center">
                    <div className="col-md-6 ">
                        <div>
                            <div className='acc text-center'>Accelerate the world's transition to cryptocurrency.</div>
                        </div>
                    </div>
                    <div className='purpose text-center text-muted'>
                        The purpose of this website is solely to display information regarding the products and services available on the Cryptgrow.com App. It is not intended to offer access to any of such products and services. You may obtain access to such products and services on the Cryptgrow.com App.


                        Please note that the availability of the products and services on the Cryptgrow.com App is subject to jurisdictional limitations. Crypto.com may not offer certain products, features and/or services on the Cryptgrow.com App in certain jurisdictions due to potential or actual regulatory restrictions.
                    </div>
                    <div>

                    </div>
                </div>

            </div>
            <div className='d-flex justify-content-center text-muted'>
                <div className="row">
                    <div className="col-md-6 offset-md-2 mt-4">
                        <h2>CRYPTOGROW.COM</h2>
                    </div>
                </div>


            </div>
        </>
    )
}
